/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_CloseInputs */

const en_mk_preview_close = /** @type {(inputs: Mk_Preview_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close preview`)
};

const id_mk_preview_close = /** @type {(inputs: Mk_Preview_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup pratinjau`)
};

/**
* | output |
* | --- |
* | "Close preview" |
*
* @param {Mk_Preview_CloseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_close = /** @type {((inputs?: Mk_Preview_CloseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_CloseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_close(inputs)
	return en_mk_preview_close(inputs)
});